(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    

  var container = document.getElementById('products_main');
  var divs = container.querySelectorAll('.subCollection');
  var divsArray = Array.from(divs);
  divsArray.sort(function(a, b) {
    return a.getAttribute('data-collection-order') - b.getAttribute('data-collection-order');
  });
  divsArray.forEach(function(div) {
    container.appendChild(div);
  });


  } catch(e) { console.error(e); }
})();
})();
